import { render, staticRenderFns } from "./bannerChild.vue?vue&type=template&id=00400d6c&"
import script from "./bannerChild.vue?vue&type=script&lang=js&"
export * from "./bannerChild.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports